module.exports = __webpack_public_path__ + "assets/footer1.f99d4b8f.svg";